import { AUTH_SOURCE } from "../constants/authSource";
import { useGlobalStore } from "../context/UserContext/userContext";

/**
 * Patient auth flags — keep `isWixAuth` and `isCreAuth` separate (never combine into one flag).
 */
export function usePatientAuthFlags() {
  const isWixAuth = useGlobalStore((s) => s.isWixAuth);
  const authSource = useGlobalStore((s) => s.authSource);
  const wixUser = useGlobalStore((s) => s.wixUser);
  const creUser = useGlobalStore((s) => s.creUser);
  const radicalUser = useGlobalStore((s) => s.radicalUser);
  const isCreAuth = authSource === AUTH_SOURCE.CRE;
  const isRadicalAuth = authSource === AUTH_SOURCE.RADICAL;

  return {
    isWixAuth,
    isCreAuth,
    isRadicalAuth,
    authSource,
    wixUser,
    creUser,
    radicalUser,
  };
}
